import React from 'react';
import { Infinity as InfinityIcon } from 'lucide-react';

const Logo = ({ tagline = false }) => (
  <a href="#top" className="flex items-center gap-2.5 group" data-testid="logo-link">
    <span className="w-9 h-9 rounded-xl bg-gradient-to-br from-violet-500 to-fuchsia-500 flex items-center justify-center shadow-[0_6px_20px_-6px_rgba(168,85,247,0.8)] transition-transform duration-300 group-hover:rotate-12">
      <InfinityIcon size={20} className="text-white" strokeWidth={2.6} />
    </span>
    <span className="font-display text-xl font-extrabold tracking-tight text-white">LoopAI</span>
    {tagline && <span className="hidden sm:inline text-xs text-white/50 ml-3">The Creative Operating System</span>}
  </a>
);

export default Logo;
